import { useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function Cursor() {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 60, damping: 20, mass: 0.6 });
  const sy = useSpring(y, { stiffness: 60, damping: 20, mass: 0.6 });

  useEffect(() => {
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  return (
    <motion.div
      data-testid="cursor-follower"
      aria-hidden
      className="pointer-events-none fixed z-50 hidden lg:block w-8 h-8 rounded-full border border-white mix-blend-difference"
      style={{ left: sx, top: sy, x: "-50%", y: "-50%" }}
    />
  );
}
